var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99992 0.333984C3.31802 0.333984 0.333252 3.31875 0.333252 7.00065C0.333252 10.6826 3.31802 13.6673 6.99992 13.6673C10.6818 13.6673 13.6666 10.6826 13.6666 7.00065C13.6666 5.23254 12.9642 3.53685 11.714 2.28661C10.4637 1.03636 8.76803 0.333984 6.99992 0.333984ZM7.66659 9.66732C7.66659 10.0355 7.36811 10.334 6.99992 10.334C6.63173 10.334 6.33325 10.0355 6.33325 9.66732V6.33398C6.33325 5.96579 6.63173 5.66732 6.99992 5.66732C7.36811 5.66732 7.66659 5.96579 7.66659 6.33398V9.66732ZM6.33325 4.33398C6.33325 4.70217 6.63173 5.00065 6.99992 5.00065C7.36811 5.00065 7.66659 4.70217 7.66659 4.33398C7.66659 3.96579 7.36811 3.66732 6.99992 3.66732C6.63173 3.66732 6.33325 3.96579 6.33325 4.33398Z",
    fill: "#004225"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.dcc182d2d994a207b43e71b1386f2979.svg";
export { ForwardRef as ReactComponent };